import { Card, CardContent } from '../../../components/ui/card'

import type { Children } from '../../../types'

function InfoCard({ children }: Children) {
  return (
    <Card>
      <CardContent>{children}</CardContent>
    </Card>
  )
}

export { InfoCard }
